import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import modalReducer from '@cred/react-modal/reducer'
import collapseReducer from '@cred/react-collapse-section/reducer'
import paginationReducer from '@cred/react-pagination/reducer'

import submissionReducer from './submission/reducer'

const components = combineReducers({
  modal: modalReducer,
  collapses: collapseReducer,
  pagination: paginationReducer,
})

const rootReducer = combineReducers({
  form: (data, action) => {
    const newAction = {
      ...action,
      payload: typeof action.payload === 'string' ? action.payload.replace(/^\s+/g, '') : action.payload,
    }
    return formReducer(data, newAction)
  },
  submission: submissionReducer,
  components,
})

export default rootReducer
